import React from 'react';
import { Col } from 'reactstrap';

import AvailabilityHeading from './AvailabilityHeading';
import TimeTableScreen from '../../../../common/operationHours/TimeTableScreen';
import TimePeriodSelection from './TimePeriodSelection';
import AvailabilityServices from './AvailabilityServices';
import AvailabilityCustomSelection from './AvailabilityCustomSelection';
import ProductDayAvailabilityScreen from './ProductDayAvailabilityScreen';

const AvailabilitySettings = props => {

    if (props.state.availabilityInfo) return null; // Fixes the bug with activating the TimeTable required fields when selected 'Custom'
    if (props.itemAvailableAllDay === undefined || props.itemAvailableAllDay === null) return <div />;

    return (
        <Col hidden={props.screen === 'product' && props.state.availabilityInfo} >
            <Col>
                <AvailabilityHeading {...props} />
                <TimePeriodSelection {...props} />
            </Col>
            {
                props.screen === 'product' && !props.itemAvailableAllDay ?
                <Col sm={12}>
                    <AvailabilityCustomSelection {...props} />
                </Col> : null
            }
            {
                props.screen === 'product' && !props.itemAvailableAllDay && props.isProductDayAvailability ?
                <Col>
                    <ProductDayAvailabilityScreen
                     {...props} 
                     availabilityDays={props.availabilityDays}
                     updateAvailabilityDaysState={props.updateAvailabilityDaysState}
                     />
                </Col> : null
            }
            <Col hidden={props.screen === 'product' && props.isProductDayAvailability} style={{ padding: 0 }}>
                <TimeTableScreen
                    preparationTimes={props.preparationTimes}
                    updatePrepTimes={props.updatePrepTimes}
                    showErrorMsg={props.showErrorMsg}
                    // Hardcoded value that diferentiates the two different types of the sub component's rendering
                    availabilitySettings={props.availabilitySettings}
                    itemAvailableAllDay={props.itemAvailableAllDay} />
            </Col>
            {
                props.screen === 'product' &&
                <AvailabilityServices
                    state={props.state}
                    changeSelectedOrderTypesState={props.changeSelectedOrderTypesState} />
            }
        </Col>
    );
}

export default AvailabilitySettings;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/AvailabilitySettings.js